import { render } from "./DataTableResults.vue?vue&type=template&id=fee8b33c"
import script from "./DataTableResults.vue?vue&type=script&lang=js"
export * from "./DataTableResults.vue?vue&type=script&lang=js"

import "./DataTableResults.vue?vue&type=style&index=0&id=fee8b33c&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__